import { get, post, del } from '@api/request';

export async function fetchIntegrityChecks(
  { integrityService },
  authenticationToken,
  { page, pageSize, processName },
) {
  let url = `${integrityService}/integrity/checks?page=${page}&pageSize=${pageSize}`;
  if (processName) {
    url = url + `&processName=${processName}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchIntegrityCheck(
  { integrityService },
  authenticationToken,
  { integrityID },
) {
  const url = `${integrityService}/integrity/check/${integrityID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function runIntegrityCheck(
  { integrityService },
  authenticationToken,
  { payload },
) {
  const url = `${integrityService}/integrity/checks`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function createIntegrityCheck(
  { integrityService },
  authenticationToken,
  { payload },
) {
  const url = `${integrityService}/integrity/checks`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchIntegrityCheckUsers(
  { integrityService },
  authenticationToken,
) {
  const url = `${integrityService}/integrity/checks/userlist`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addIntegrityCheckUser(
  { integrityService },
  authenticationToken,
  { payload },
) {
  const url = `${integrityService}/integrity/checks/userlist`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteIntegrityCheckUser(
  { integrityService },
  authenticationToken,
  { integrityEmailID },
) {
  const url = `${integrityService}/integrity/checkuser/${integrityEmailID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchProcessList(
  { integrityService },
  authenticationToken,
  { process },
) {
  let url = `${integrityService}/integrity/checks/processlist`;
  if (process) {
    url += `?process=${process}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addProcessCheck(
  { integrityService },
  authenticationToken,
  { payload },
) {
  const url = `${integrityService}/integrity/checks/processlist`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteProcessCheck(
  { integrityService },
  authenticationToken,
  { integrityProcessID },
) {
  const url = `${integrityService}/integrity/checkprocess/${integrityProcessID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchProcessDetails(
  { integrityService },
  authenticationToken,
  { integrityID },
) {
  const url = `${integrityService}/integrity/check/${integrityID}/details`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchProcessErrors(
  { integrityService },
  authenticationToken,
  { integrityID, page = 1, pageSize = 10000 },
) {
  const url = `${integrityService}/integrity/check/${integrityID}/errors?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchProcessDetailErrors(
  { integrityService },
  authenticationToken,
  { integrityDetailID, page = 1, pageSize = 10000 },
) {
  const url = `${integrityService}/integrity/check/detail/${integrityDetailID}/errors?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchProcessTypes(
  { integrityService },
  authenticationToken,
) {
  const url = `${integrityService}/integrity/check/processtypes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchIntegrityChecksByProcess(
  { integrityService },
  authenticationToken,
  { processName, processID },
) {
  const url = `${integrityService}/integrity/check/byprocess/${processName}/${processID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}
